<div class="download-tray" *ngIf="downloads.jobs().length">
  <div class="tray-header" (click)="downloads.minimized.set(!downloads.minimized())">
    <span>
      <i class="bi bi-calendar3"></i>
      {{ runningCount ? 'Preparing ' + runningCount + ' download' + (runningCount > 1 ? 's' : '') : 'Downloads' }}
    </span>
    <i class="bi" [ngClass]="downloads.minimized() ? 'bi-chevron-up' : 'bi-chevron-down'"
      [matTooltip]="downloads.minimized() ? 'Expand' : 'Minimize'"></i>
  </div>

  <div class="tray-body" *ngIf="!downloads.minimized()">
    <div class="tray-job" *ngFor="let job of downloads.jobs(); trackBy: trackById" [ngClass]="job.status">
      <div class="job-row">
        <span class="job-name" [matTooltip]="job.themeName">{{ job.themeName }}</span>
        <i *ngIf="job.status === 'done'" class="bi bi-check-circle-fill status-icon done-icon"></i>
        <i *ngIf="job.status === 'error'" class="bi bi-exclamation-circle-fill status-icon error-icon"></i>
        <button class="btn-icon" (click)="downloads.remove(job.id)"
          [matTooltip]="job.status === 'running' ? 'Cancel' : 'Dismiss'">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="job-progress">
        <div class="job-progress-bar" [style.width.%]="progress(job)"></div>
      </div>
      <div class="job-stage">{{ job.stage }}</div>
      <div class="job-hint" *ngIf="job.status === 'running'">
        <i class="bi bi-hourglass-split"></i>
        Broad themes can take several minutes. Feel free to keep working.
      </div>
      <div class="job-skipped" *ngIf="job.skipped.length">Skipped (failed): {{ skippedLabel(job) }}</div>
    </div>
  </div>
</div>
